/**
 * Single owner of the "contact display name or fallback" rule (OP-7428 review): the
 * trimmed-name-or-i18n-fallback expression was previously restated at 8 call sites across 4
 * files with two different i18n keys, so a change to the fallback rule (or a key rename) could
 * update some sites and miss others — the same nameless contact then renders differently
 * between the designation modal and the confirm modal's household line.
 */
/** Returns the trimmed name, or the caller-resolved fallback when the name is null/blank. */
export function displayNameOr(name, fallback) {
    return name?.trim() || fallback;
}
/**
 * i18n-aware variant for call sites holding a `t` function. The default key is the historical
 * shared-email one; household-designation sites pass their own namespace's key.
 */
export function contactDisplayName(name, t, fallbackKey = "contact.detail.designatePrimary.unknownContact") {
    return displayNameOr(name, t(fallbackKey));
}
